import styles from './styles/Button.listItem.module.scss';
import React from 'react';
import { defaultSearchParams } from '../../configs';
import { Ssvg } from '../../../Components/react/Ssvg';
import { FACET_KEY_MEDIUMS } from '../../constants/facetKeys';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { handleize } from '../../../js/helpers/handleize';
export const ButtonListItem = ({ fConfig, fKey, label, value, count, activeValues, itemClickHandler, textForHighlight }) => {
    const [searchParams] = useSearchParams();
    const { handle } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const isDisabled = count === 0;
    const isActiveAsDefault = defaultSearchParams.facets[fKey]?.includes(value);
    const isActive = isActiveAsDefault || activeValues.includes(value);
    const className = `btn:cleared w:100p d:flex ai:center trs:all:300 ${styles.itemButton} ${isActive ? `fw:700 ${styles.itemButtonActive}` : ''}`;
    const ariaDescribedby = isDisabled
        ? 'adb_disabled'
        : isActive
            ? 'adb_selected adb_filter-clear'
            : 'adb_filter-add';
    const clickHandler = (event) => {
        event.preventDefault();
        if (!isActiveAsDefault && !isDisabled) {
            itemClickHandler(value, fKey);
        }
    };
    const labelForRender = textForHighlight !== undefined && textForHighlight.length > 0
        ? label.split(new RegExp(`(${textForHighlight})`, 'gi')).map((str, i) => {
            return i % 2 !== 0
                ? React.createElement("span", { className: "fw:700", key: i }, str)
                : React.createElement("span", { key: i }, str);
        })
        : React.createElement("span", null, label);
    const content = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: `d:flex ai:center jc:center bdrs:1 lh:0 ${styles.checkbox}` }, isActive && React.createElement(Ssvg, { icon: '#icon--check-mark', aspectRatio: "12 / 11", className: styles.checkboxCheckMark })),
        React.createElement("span", { className: "text:left text:capitalize" },
            labelForRender,
            React.createElement("span", { className: styles.count },
                "(",
                count,
                React.createElement("span", { className: "sr-only" },
                    " item",
                    count > 1 ? 's' : ''),
                ")"))));
    if (fConfig.fakeLinks === true) {
        let href = `/${pagePath}`;
        if (handle !== undefined) {
            href += `/${handle}`;
        }
        if (fKey === FACET_KEY_MEDIUMS) {
            if (!isActive) {
                href += `/${handleize(value)}`;
            }
        }
        else {
            if (isActive) {
                if (fConfig.singleSelect) {
                    searchParams.set(fKey, value);
                }
                else {
                    searchParams.set(fKey, activeValues.filter(v => v !== value).join(','));
                }
            }
            else {
                searchParams.delete(fKey);
            }
        }
        const spString = searchParams.toString();
        if (spString.length > 0) {
            href += `?${spString}`;
        }
        return (React.createElement("a", { className: className, href: href, "aria-describedby": ariaDescribedby, onClick: clickHandler }, content));
    }
    return (React.createElement("button", { className: className, "aria-describedby": ariaDescribedby, onClick: clickHandler, "data-cy-test": `${isActiveAsDefault ? 'CollectionFilterItemButton-Active' : 'CollectionFilterItemButton'}` }, content));
};
